export const blockIconsPhotoandimageLandscapeNew = (
	<span className='material-symbols-outlined'>landscape</span>
);
